import apiClient from './client'
import type { Cliente, CreateClienteRequest, UpdateClienteRequest, PaginatedResponse } from '@/types/cliente'

function normalizeClientePayload(data: CreateClienteRequest | UpdateClienteRequest) {
    return {
        ...data,
        provincia: typeof data.provincia === 'string' || data.provincia == null
            ? data.provincia ?? undefined
            : data.provincia.idAuxiliar,
    }
}

export const clientesApi = {
    getAll: (params?: { search?: string; activo?: number; page?: number; pageSize?: number }) =>
        apiClient.get<PaginatedResponse<Cliente>>('/clientes', { params }).then((r) => r.data),

    exportarExcel: (params?: { search?: string; activo?: number }) =>
        apiClient.get<Blob>('/clientes/export', {
            params,
            responseType: 'blob',
        }).then((r) => ({
            archivo: r.data,
            nombreArchivo: extraerNombreArchivo(r.headers['content-disposition']) ?? 'clientes.xlsx',
        })),

    getById: (id: string) =>
        apiClient.get<Cliente>(`/clientes/${id}`).then((r) => r.data),

    create: (data: CreateClienteRequest) =>
        apiClient.post<Cliente>('/clientes', normalizeClientePayload(data)).then((r) => r.data),

    update: (id: string, data: UpdateClienteRequest) =>
        apiClient.put<Cliente>(`/clientes/${id}`, normalizeClientePayload(data)).then((r) => r.data),

    delete: (id: string) =>
        apiClient.delete(`/clientes/${id}`),
}

function extraerNombreArchivo(contentDisposition?: string): string | null {
    if (!contentDisposition) {
        return null
    }

    const coincidenciaUtf8 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
    if (coincidenciaUtf8?.[1]) {
        return decodeURIComponent(coincidenciaUtf8[1])
    }

    const coincidenciaBasica = contentDisposition.match(/filename="?([^"]+)"?/i)
    return coincidenciaBasica?.[1] ?? null
}
